import { render, staticRenderFns } from "./MemberPointsTable.vue?vue&type=template&id=5136b1de&scoped=true&lang=pug&"
import script from "./MemberPointsTable.vue?vue&type=script&lang=js&"
export * from "./MemberPointsTable.vue?vue&type=script&lang=js&"
import style0 from "./MemberPointsTable.vue?vue&type=style&index=0&id=5136b1de&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5136b1de",
  null
  
)

export default component.exports